import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { getInvalidFieldsV3 } from '../../functions/functions';
import { cloneArray } from '../../functions/shared-functions';
import { viewDocument } from '../files/files.component';
import { setDefaultValue } from 'src/app/functions/shared-functions';

@Component({
  selector: 'tm-data-table',
  templateUrl: './tm-data-table.component.html',
  styleUrls: ['./tm-data-table.component.scss']
})
export class TmDataTableComponent implements OnInit {

  @Input() form_group;
  @Input() section;
  @Input() masters;
  @Input() parent_form;
  @Input() verificationObj;
  @Input() readOnly;

  grid_layout = [];
  table_data = [];
  columns = [];
  constructor(
    private notification: NotificationService,
    private translate: TranslateService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.prepareGridColumns();
  }

  editTableItem(index, base_fg, form_control, form_group) {
    let val = []
    val = base_fg.get(form_control).value || [];
    let edit_val = val.splice(index, 1)
    base_fg.get(form_control).patchValue(val);
    if (edit_val && typeof edit_val == 'object' && edit_val[0]) {
      form_group.patchValue(edit_val[0]);
    }
    else {
      form_group.patchValue(edit_val);
    }
  }
  view(item?) {
    viewDocument(item, item[0], this.dialog, null, "fileName", "cdnPath");
  }

  addToTable(base_fg, form_control, form_group) {
    if (form_group.valid) {
      let val = base_fg.get(form_control).value || [];
      val = cloneArray(val);
      val.push(form_group.value);
      base_fg.get(form_control).patchValue(val);
      form_group.reset();
      this.setDefaultValue(form_group)
    }
    else {
      getInvalidFieldsV3(this.section.multiple_form, this.translate, this.notification, this.section);
      // getInvalidFields(form_group, this.translate, this.notification_svc, 'PRE_OFFER.', 1, this.field_config_access);
    }
  }

  setDefaultValue(form_group) {
    try {
      for (let index = 0; index < this.columns?.length; index++) {
        const column = this.columns[index];
        if ((column.dataTypeId == 8 || column.dataTypeId == 9 || column.dataTypeId == 11) && column?.masterPropName && this.masters[column?.masterPropName]) {
          let masters; if (column['allOptionsPropName']) { masters = this.masters[column['allOptionsPropName']]; }
          else if (column['masterPropName']) { masters = this.masters[column['masterPropName']]; }

          setDefaultValue(form_group, column.fieldID, masters, 'id')
        }
      }
    }
    catch (err) {

    }
  }

  deleteTableItem(index, base_fg, form_control, form_group) {
    let val = []
    val = base_fg.get(form_control).value || [];
    let edit_val = val.splice(index, 1)
    form_group.patchValue(edit_val);
  }

  prepareGridColumns() {
    try {
      if (this.section && this.section.table_grid && this.section.table_grid.length) {
        this.columns = [];
        for (let i = 0; i < this.section.sectionFields.length; i++) {
          for (let j = 0; j < this.section.table_grid.length; j++) {
            if (this.section.table_grid[j].property == this.section.sectionFields[i].fieldID) {
              let obj = Object.assign({}, this.section.sectionFields[i]);
              if (this.section.table_grid[j].title) {
                obj.label = this.section.table_grid[j].title;
              }
              this.columns.push(obj);
            }
          }
        }
      }
      else {
        this.columns = this.section.sectionFields;
      }
    }
    catch (err) {
      this.columns = this.section.sectionFields;
    }
  }
}
